// Socket.io-клиент для realtime-событий заведения. Бэкенд шлёт order.created /
// order.updated / order.paid / order.completed / order.cancelled в комнату
// `est:<establishmentId>`. Мы подключаемся по токену клиента — он уже содержит
// establishmentId, а middleware сервера сам подписывает нас на нужную комнату.
//
// Используется на Checkout'е, чтобы мгновенно обновлять список свободных
// столиков без поллинга.

import { io, type Socket } from 'socket.io-client';

import { useAuthStore } from '@/store/auth.store';

const baseURL = import.meta.env.VITE_API_URL?.trim() || '';

let socket: Socket | null = null;

export function getSocket(): Socket | null {
  const token = useAuthStore.getState().accessToken;
  if (!token) {
    // Без токена сервер не пустит — не держим dead-connect.
    if (socket) {
      socket.disconnect();
      socket = null;
    }
    return null;
  }

  if (socket && socket.connected) return socket;

  if (!socket) {
    socket = io(baseURL || window.location.origin, {
      path: '/socket.io',
      transports: ['websocket'],
      auth: { token },
      reconnection: true,
      reconnectionDelay: 1_000,
      reconnectionDelayMax: 5_000,
    });
  } else {
    // Обновляем токен на случай, если access успел обновиться после refresh.
    socket.auth = { token };
    if (!socket.connected) socket.connect();
  }
  return socket;
}

export function closeSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
